export default function NotFoundPage() {
  return (
    <div className="custom-container">
      <p className="p-5">Pagina no encontrada</p>
    </div>
  )
}
